/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

const baseStyles = () => {
    return css`
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: var(--layout-spacing-8);

        li {
            min-height: 2.6rem;
        }

        .attribute-label {
            ${theme.typography.body_small};
        }

        .attribute-value {
            ${theme.typography.body_small_highlight}
        }
    `;
};

export const styles = () => css`
    ${baseStyles()}
`;
